module.exports = __webpack_public_path__ + "img/laprecision-logo-p.da0c91c6.svg";